import * as React from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Link,useNavigate } from "react-router-dom"; // Assuming you are using react-router
import logo from "../../Components/Assets/images/siteLogoWhite.svg";
import { useSelector, useDispatch } from "react-redux";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Zoom from "@mui/material/Zoom";
import { motion, AnimatePresence } from "framer-motion";
import { Tooltip } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DescriptionIcon from "@mui/icons-material/Description";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import PasswordIcon from "@mui/icons-material/Password";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import LogoutIcon from "@mui/icons-material/Logout";
import configServ from "../../services/config";
import LoaderNew from "../Loader/LoaderNew";
import Logout from "../Logout/Logout";

export default function CustomerSideBarReBuild({ open, toggleSidebar }) {
  const [isLogutDialogOpen, setIsLogutDialogOpen] = React.useState(false);

  const { company_type } = useSelector((state) => state.admin);
  
  const handleLogout = () => {
    setIsLogutDialogOpen(!isLogutDialogOpen);
  };

  const navigate = useNavigate();
  const [expandedMenu, setExpandedMenu] = React.useState(null); // Track expanded menu
  const [menus, setMenus] = React.useState([]);

  const handleMenuClick = (menu) => {
    if (menu.submenus.length === 0) {
      navigate(menu.routes); // Navigate directly
    } else {
      setExpandedMenu(expandedMenu === menu.id ? null : menu.id); // Toggle submenu
    }
  };

  const handleSubmenuClick = (route) => {
    navigate(route);
  };

  const [loading, setLoading] = React.useState(false);

  const fetchMenuList = async () => {
    setLoading(true);
    try {
      const res = await configServ.getCustomerActiveMenusWithSubmenus();
      if (res.status === 200 && Array.isArray(res.data)) {
        setMenus(res.data || []);
      } else {
        setMenus([]);
        // toast.error("Failed to fetch menu list.");
      }
    } catch (e) {
      // toast.error("An error occurred!");
      console.log(e);
      setMenus([]);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchMenuList();
  }, []);

  // Icon mapping object
  const iconMapping = {
    dashboard: <DashboardIcon />,
    invoice: <DescriptionIcon />,
    product: <ProductionQuantityLimitsIcon />,
    purchasecustomer: <ShoppingBasketIcon />,
    payment: <AccountBalanceIcon />,
    profile: <AccountBoxIcon />,
    password: <PasswordIcon />,
    leadger: <LeaderboardIcon />,
    logout: <LogoutIcon />,
  };
  const getIcon = (iconName) => {
    return iconMapping[iconName.toLowerCase()] || null; // Return null if icon doesn't exist
  };

  const NavToolTip = ({ text, children }) => {
    return (
      <Tooltip
        TransitionComponent={Zoom}
        leaveDelay={200}
        title={text}
        placement="right"
        arrow
        sx={{ fontSize: "16px" }}
      >
        {children}
      </Tooltip>
    );
  };
  return (
    <>
      <Logout open={isLogutDialogOpen} setOpen={setIsLogutDialogOpen} />
      <Drawer
        open={open}
        onClose={toggleSidebar}
        sx={{
          "& .MuiDrawer-paper": {
            backgroundColor: "rgb(51,51,51)", // Set entire drawer background to black
            color: "white", // Ensure text color is white throughout
          },
        }}
      >
        <List>
          {/* Logo at the top */}
          <ListItem>
            <img
              src={logo} // Replace with your logo URL
              alt="Company Logo"
              width="150"
              style={{
                margin: "16px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
              }} // Center the logo
            />
          </ListItem>

          {/* Menu Items */}
          {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoaderNew /> {/* Replace with your loader icon/component */}
          </div>
        ) : (
          <>
            {" "}
            {/* Iterate Menus */}
            {menus.map((menu) => (
              <div key={menu.id}>
                {/* Main Menu */}
                <div
                  onClick={() => {
                    toggleSidebar()
                    if (menu.name === "Log Out") {
                      handleLogout(); // Trigger the logout function
                    } else {
                      handleMenuClick(menu); // Handle other menu clicks
                    }
                  }}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                    color: "white",
                    display: "flex",
                    justifyContent: open ? "space-between" : "center",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px", // Add spacing between icon and name
                    }}
                  >
                    <NavToolTip text={menu.name}>
                      {getIcon(menu.icon)}
                    </NavToolTip>{" "}
                    {open && menu.name}
                  </span>
                  {menu.submenus.length > 0 &&
                    (expandedMenu === menu.id ? (
                      <ArrowDropUpIcon />
                    ) : (
                      <ArrowDropDownIcon />
                    ))}
                </div>

                {/* Submenus */}
                <AnimatePresence>
                  {expandedMenu === menu.id && menu.submenus.length > 0 && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <ul style={{ listStyle: "none", paddingLeft: "20px" }}>
                        {menu.submenus.map((submenu) => (
                          <li key={submenu.id}>
                            <div
                              onClick={() => handleSubmenuClick(submenu.routes)}
                              style={{
                                cursor: "pointer",
                                padding: "8px",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                gap: "12px", // Add spacing for submenu items
                              }}
                            >
                              <NavToolTip text={submenu.name}>
                                {getIcon(submenu.icon)}
                              </NavToolTip>
                              {open && submenu.name}{" "}
                              {/* Only show name if sidebar is open */}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </>
        )}
        </List>
      </Drawer>
    </>
  );
}
